import styled from "styled-components";
import Card from "@mui/material/Card";

interface IAnnouncementsCardProps {
  minHeight?: any;
}

export const max2lines = `
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const cardItem = (theme: any) => `
  cursor: pointer;
  border-radius: ${theme.uptimeSpace[5]}px !important;
  &:hover {
      border-color: transparent;
      box-shadow: 0 1px 2px -2px rgba(0,0,0,0.16), 0 3px 6px 0 rgba(0,0,0,0.12), 0 5px 12px 4px rgba(0,0,0,0.09);
  }
`;

export const heading5 = (theme: any) => `
  font-size: ${theme.uptimeFontSizes.mobile.fz6}px;
  line-height: ${theme.uptimeLineHeights.mobile.lh6}px;
  font-weight: normal;
  @media (min-width: 960px) {
    font-size: ${theme.uptimeFontSizes.desktop.fz7}px;
    line-height: ${theme.uptimeLineHeights.desktop.lh5}px;
  }
`;

export const captionRegular = (theme: any) => `
  font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
  line-height: ${theme.uptimeLineHeights.desktop.lh3}px;
  color: ${theme.uptimeColors.textColors.primary};
  font-family: '${theme.uptimeFonts.primary}'${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
`;

export const AnnouncementsCardStyled = styled(Card)<IAnnouncementsCardProps>`
  ${({ theme, minHeight }) => `
    height: 146px !important;
    width: 100%;
    ${cardItem(theme)};

    .announcements-card-body {
      padding-top: ${theme.uptimeSpace[6]}px;
      .announcements-card-header{
        EyeBrow{
          min-height: ${minHeight ? "18px" : ""};
        }
      }
      .announcements-card-title {
        ${max2lines};
        color: $black;
        -webkit-line-clamp: 2;
        margin-top: ${theme.uptimeSpace[4]}px;
        line-height: ${theme.uptimeDynamicAlignCenter?.newsAndKnowledge?.announcements?.lineHeightTitle ?? `${theme.uptimeLineHeights.desktop.lh5}px`} !important;
        font-size: ${theme.uptimeFontSizes.mobile.fz6}px;
        font-weight: normal;
        @media (min-width: 960px) {
          font-size: ${theme.uptimeDynamicFontSize?.announcementsCard?.title};
        }
      }

      .announcements-card-content {
        font-size: ${theme.uptimeDynamicFontSize?.announcementsCard?.desc};
        line-height: ${theme.uptimeLineHeights.desktop.lh3}px;
        color: ${theme.uptimeColors.textColors.primary};
        ${max2lines};
        margin-top: ${theme.uptimeSpace[4]}px;
        // min-height: 36px;
        line-height: ${theme.uptimeDynamicAlignCenter?.newsAndKnowledge?.announcements?.lineHeightContent ?? `${theme.uptimeLineHeights.desktop.lh3 + 1}px`} !important;
        -webkit-line-clamp: 2;
        color: ${theme.uptimeColors.grayScales.darkerGray};
      }

    }
  `}
`;
